import { SnackbarContent, CustomContentProps } from 'notistack';
import { Alert } from '@mui/material';
import { forwardRef } from "react";

export const CustomSnackbar = forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
    const {
        id,
        message,
        variant,
        style,
        ...other
    } = props

    return (
        <SnackbarContent
            ref={ref}
            role="alert"
            style={{
                minWidth: 380,
                maxWidth: 380,
            }}
            {...other}
        >
            <Alert
                severity="error"
                variant="filled"
                sx={{
                    width: '100%',
                    alignItems: 'center',
                }}
            >
                {message}
            </Alert>
        </SnackbarContent>
    )
})

export function CustomSnackbar1(props: CustomContentProps) {
    const { message, variant } = props;

    return (
        <SnackbarContent
            style={{
                minWidth: 320,
                maxWidth: 320,
            }}
        >
            <Alert
                // severity={variant}
                variant="filled"
                sx={{
                    width: '100%',
                    alignItems: 'center',
                }}
            >
                {message}
            </Alert>
        </SnackbarContent>
    );
}